import React from 'react'

const ButtonModalClose = ({ title, onClick, disabled }) => {
    return (
        <div className='text-center'>
            <button
                className='btn  btn-outline my-3 shadow rounded' 
                disabled={disabled} 
                onClick={onClick} 
                data-bs-dismiss="modal" aria-label="Close"
            >{title}</button>
        </div>
    )
}

export default ButtonModalClose
